export default __webpack_public_path__ + "static/media/summaryMobile.13d5c224.svg";